import { apiRequest } from '../../apiCall'


export const getGeneralLineSettings = (id) => apiRequest('CustomerLine.generalLineSettings', {}, `?customerLineId=${id}`, true)
export const getCustomerLineServices = (id) => apiRequest('LineSettings.customerLineServices', {}, `?customerLineId=${id}`)
export const getCallReportSettings = (id) => apiRequest('LineSettings.callReportSettings', {}, `?customerLineId=${id}`)
export const getLineFaxSettings = (id) => apiRequest('LineSettings.lineFaxSettings', {}, `?customerLineId=${id}`)
export const getLineVoicemailSettings = (id) => apiRequest('LineSettings.lineVoicemailSettings', {}, `?customerLineId=${id}`)
export const getCustomerMembers = () => apiRequest('CustomerMember.customerMembers', {}, ``, true)
export const getPasswordStatus = (id) => apiRequest('directOutgoingCallPassword.passwordStatus', {}, `?customerLineId=${id}`)
export const setGeneralLineSettings = (params) => apiRequest('CustomerLine.SetGeneralLineSettings', { ...params }, "", true)
export const setCallReportSettings = (params) => apiRequest('LineSettings.SetCallReportSettings', { ...params },)
export const setLineFaxSettings = (params) => apiRequest('LineSettings.SetLineFaxSettings', { ...params },)
export const setLineVoicemailSettings = (params) => apiRequest('LineSettings.SetLineVoicemailSettings', { ...params },)
export const setPasswordStatus = (params) => apiRequest('directOutgoingCallPassword.SetPasswordStatus', {}, `?customerLineId=${params.id}&status=${params.status}`)
export const setPassword = (params) => apiRequest('directOutgoingCallPassword.SetPassword', { ...params },)
export const getLineSeparationSettings = (id) => apiRequest('LineSettings.getLineSeparationSettings', {}, `?customerLineId=${id}`)
export const postUploadmusicOnHoldRequest = (file) => apiRequest('IvrFile.Upload', file, ``, true)



















